<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <v-row justify="space-between">
      <h2 style="margin-left: 1rem;">
        Uredite prevzemnico:
      </h2>
      <v-btn
        color="#0F998E"
        class="white--text"
        style="margin-right: 1rem;"
        @click="printAcceptanceForm"
      >
      Tiskaj
      <v-icon right dark>mdi-printer</v-icon>
      </v-btn>
    </v-row>

    <AcceptanceFormForm
      ref="acceptanceformform"
      :clients="clients"
      :acceptanceForm="acceptanceForm"
      :countryList="countryList"
      :skrij="true"
      @sprememba="spremeni"
      @save="save"
      @cancel="cancel"
    />

    <v-row>
      <v-col>
        <v-simple-table
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th v-if="isFinanceFoodForm" class="text-left">
                  Cena
                </th>
                <th v-else class="text-left">
                  Količina
                </th>
                <th class="text-left">
                  Naziv artikla
                </th>
                <th class="text-left">
                  Merska enota
                </th>
                <th v-if="isFinanceFoodForm" class="text-left">
                  Količina
                </th>
                <th v-else class="text-left">
                  Cena
                </th>
                <th class="text-left">
                  Popust
                </th>
                <th class="text-left">
                  Marža %
                </th>
                <th class="text-left">
                  Marža znesek
                </th>
                <th class="text-left">
                  Vrednost
                </th>
                <th class="text-left">
                  DDV %
                </th>
                <th class="text-left">
                  DDV vrednost
                </th>
                <th class="text-left">
                  Cena z DDV/MPC
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <AcceptanceFormArticleRow
                v-for="(article, index) in localArticles"
                ref="acceptanceFormArticleRow"
                :key="index"
                :article="article"
                :articles="articles"
                :isFinanceFoodForm="isFinanceFoodForm"
                @delete="deleteArticle(index)"
                @update="updateArticleRowInLocalArray(index, $event)"
              >
              </AcceptanceFormArticleRow>

              <AcceptanceFormArticleRow
                v-if="addingArticle"
                :articles="articles"
                :acceptanceFormId="id"
                :isFinanceFoodForm="isFinanceFoodForm"
                @cancel="addingArticle = false"
                @save="addArticleRowToLocalArray"
              />
              <tr v-if="localArticles.length > 0" style="font-weight: bold; border-top: 2px solid #000000;">
                <td v-if="isFinanceFoodForm" style="border-top: 2px solid #000000;"></td>
                <td v-else style="border-top: 2px solid #000000;">Skupaj</td>
                <td style="border-top: 2px solid #000000;"></td>
                <td style="border-top: 2px solid #000000;"></td>
                <td v-if="isFinanceFoodForm" style="border-top: 2px solid #000000;">Skupaj</td>
                <td v-else style="border-top: 2px solid #000000;"></td>
                <td style="border-top: 2px solid #000000;"></td>
                <td style="border-top: 2px solid #000000;"></td>
                <td style="border-top: 2px solid #000000;"></td>
                <td style="border-top: 2px solid #000000;">{{ valueSumFormatted }}</td>
                <td style="border-top: 2px solid #000000;"></td>
                <td style="border-top: 2px solid #000000;"></td>
                <td style="border-top: 2px solid #000000;"></td>
                <td style="border-top: 2px solid #000000;"></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <v-btn
        color="#0F998E"
        class="white--text ml-3"
        @click="addingArticle = true"
        :disabled="addingArticle"
      >
        Dodaj postavko
        <v-icon right dark>mdi-plus</v-icon>
      </v-btn>
      <v-btn
        v-if="!isFinanceFoodForm"
        color="#0F998E"
        class="white--text ml-3"
        @click="toggleShowAddArticleModal"
      >
        Nov artikel
        <v-icon right dark>mdi-plus</v-icon>
      </v-btn>
      <v-btn
        color="#0F998E"
        class="white--text ml-3"
        :disabled="false"
        @click="undoChanges"
      >
        Prekliči
      </v-btn>
      <v-btn
        color="#0F998E"
        class="white--text ml-3"
        :disabled="!unsavedChanges"
        @click="doSaveAcceptanceFormArticles"
      >
        Shrani
      </v-btn>
    </v-row>
    <v-row>
      <v-col class="mt-12"></v-col>
    </v-row>
    <div ref="bottomOfThePage" style="height: 50px;"></div>
    <PopupAddArticle
      ref="addArticleModal"
      v-model="showAddArticleModal"
      @confirmed="addArticle"
    />
    <ConfirmDialog
      ref="confirmdialogunsaved"
      title="Opozorilo"
      text="Ali želiš izhod brez shranjevanja podatkov?"
      okBtnText="Razumem"
      :normal="false"
      v-model="showWarningModal"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import { saveItem } from '@/utils/crudFunctions'
import AcceptanceFormForm from '@/components/AcceptanceFormForm'
import AcceptanceFormArticleRow from '@/components/AcceptanceFormArticleRow'
import PopupAddArticle from '@/components/PopupAddArticle'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import ConfirmDialog from '@/components/ConfirmDialog'
import { objectToArray } from '@/utils/object'
import { siFloatToFloat } from '@/utils/number'
import { parsePrice } from '@/utils/price'

export default {
  components: {
    AcceptanceFormForm,
    AcceptanceFormArticleRow,
    PopupAddArticle,
    ConfirmDialog
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      countryList: [],
      localArticles: [],
      unsavedChanges: false,
      showAddArticleModal: false,
      addingArticle: false,
      showWarningModal: false
    }
  },
  computed: {
    clients () {
      return objectToArray(this.$store.state.clients.items)
    },
    articles () {
      return objectToArray(this.$store.state.articles.inventoryItems)
    },
    acceptanceForm () {
      const accForm = this.$store.state.acceptanceForms.items[this.id]
      if (!accForm) return accForm
      return {
        ...accForm,
        date: moment(accForm.date).format('YYYY-MM-DD')
      }
    },
    isFinanceFoodForm () {
      return this.acceptanceForm && this.acceptanceForm.type === 1
    },
    valueSum () {
      return this.localArticles.reduce((sum, article) => {
        if (!article) return sum
        const buyingPrice = siFloatToFloat(article.price || 0)
        const discount = siFloatToFloat(article.discount || 0)
        const quantity = siFloatToFloat(article.quantity || 0)
        const discountAmount = (discount / 100) * buyingPrice
        const value = quantity * (buyingPrice - discountAmount)
        return sum + (isNaN(value) ? 0 : value)
      }, 0)
    },
    valueSumFormatted () {
      return parsePrice(this.valueSum, 2)
    }
  },
  methods: {
    ...mapActions('acceptanceForms', ['loadItem', 'saveItem', 'articleMargin']),
    ...mapActions('companies', ['getCountries']),
    ...mapActions('clients', { loadClients: 'loadItems' }),
    ...mapActions('articles', { saveArticle: 'saveItem', loadArticles: 'loadInventoryItems' }),
    ...mapActions('acceptanceFormArticles', { saveAcceptanceFormArticles: 'saveItems' }),
    handleFocusOut () {
      this.showWarningModal = true
    },
    printAcceptanceForm () {
      let routeData = this.$router.resolve({ name: 'MyCompanyAcceptanceFormPreview', params: { id: this.id } })
      window.open(routeData.href, '_blank')
    },
    spremeni () {
      this.unsavedChanges = !this.unsavedChanges
    },
    save ({ data }) {
      saveItem(data, 'MyCompanyAcceptanceForms', this)
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyAcceptanceForms' })
    },
    toggleShowAddArticleModal () {
      this.showAddArticleModal = true
    },
    doSaveAcceptanceFormArticles () {
      this.saveAcceptanceFormArticles({
        acceptanceFormId: this.id,
        items: {
          articles: this.localArticles
        }
      })
        .then(response => {
          this.unsavedChanges = false
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          this.$refs.acceptanceformform.save()
        })
    },
    addArticle ({ data }) {
      this.saveArticle(data)
        .then(newArticle => {
          this.loadArticles()
            .then(response => {
              /* this.$notify({
                type: 'success',
                text: 'Podatki so bili uspešno shranjeni.'
              }) */
            })
        })
    },
    updateArticleRowInLocalArray (index, article) {
      this.localArticles[index] = article
      this.unsavedChanges = true
      this.setMarginForArticleOnIndex(article, index)
    },
    addArticleRowToLocalArray (article) {
      this.addingArticle = false
      article.saving = true
      this.localArticles.push(article)
      const index = this.localArticles.length - 1
      this.setMarginForArticleOnIndex(article, index)
      this.unsavedChanges = true
      this.$nextTick(() => {
        this.addingArticle = true
      })
      this.$refs.bottomOfThePage.scrollIntoView()
    },
    setMarginForArticleOnIndex (article, index) {
      this.getMargin(article)
        .then(marginData => {
          this.localArticles[index].margin = siFloatToFloat(marginData.percent)
          this.localArticles[index].marginValue = siFloatToFloat(marginData.value)
          this.$refs.acceptanceFormArticleRow[index].setStartingArticleFields(article)
          this.$refs.acceptanceFormArticleRow[index].stopSaving()
        })
        .catch(anErr => {
          this.localArticles[index].margin = null
          this.localArticles[index].marginValue = null
          this.$refs.acceptanceFormArticleRow[index].setStartingArticleFields(article)
          this.$refs.acceptanceFormArticleRow[index].stopSaving()
        })
    },
    async getMargin (article) {
      const articleData = await this.articleMargin({
        acceptanceFormId: this.id,
        params: {
          article: article.article,
          quantity: article.quantity,
          price: article.price,
          discount: article.discount
        }
      })
      return {
        value: articleData.margin,
        percent: articleData.margin_percent
      }
    },
    deleteArticle (index) {
      this.localArticles.splice(index, 1)
      const newArray = this.localArticles
      this.localArticles = []
      this.$nextTick(() => {
        this.localArticles = newArray
      })
      this.unsavedChanges = true
    },
    undoChanges () {
      this.loadItem(this.id)
        .then(response => {
          this.localArticles = []
          this.$nextTick(() => {
            this.localArticles = response.articles
          })
          this.unsavedChanges = false
          this.addingArticle = false
          if (this.$refs.acceptanceFormArticleRow) {
            this.$refs.acceptanceFormArticleRow.forEach((ref) => {
              ref.setStartingArticleFields()
              this.$router.go(-1)
            })
          } else {
            this.$router.push({ name: 'MyCompanyAcceptanceForms' })
          }
        })
    }
  },
  created () {
    Promise.all([
      this.getCountries(),
      this.loadItem(this.id),
      this.loadClients(),
      this.loadArticles()
    ])
      .then(response => {
        this.countryList = response[0]
        this.localArticles = response[1].articles
        this.asyncDataStatus_fetched()
      })
  },
  async beforeRouteLeave (to, from, next) {
    if (to.name === 'MyCompanyAcceptanceForms') {
      next()
    } else {
      this.showWarningModal = true
      next(await this.$refs.confirmdialogunsaved.pop())
    }
  }
}
</script>
